// apps/files-manager/src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import FileManagerLayout from './layouts/FileManagerLayout';
import Login from './pages/Login';

// --- Main Pages --------------------------------------------------
import Dashboard from './pages/Dashboard';
import Portfolio from './pages/Portfolio';
import Products from './pages/Products';
import StoreManager from './pages/StoreManager';
import BulkStoreUpload from './pages/BulkStoreUpload';
import EBooks from './pages/EBooks';
// ?? ???? ????? � ??? ??? ???? components/admin ? ???
import BlogPostsManagement from './components/admin/BlogPostsManagement';
// ?? ???? ???? ??? � components/admin ? ???? ????
import BlogFormPage from './components/admin/BlogFormPage';
import Videos from './pages/Videos';
import Calculators from './pages/Calculators';
import Gallery from './pages/Gallery';

// --- Property Pages (I wrote these) ---
import Properties from './pages/Properties';
import PropertyForm from './components/admin/PropertyForm';

// --- Other Pages ---
import Customers from './pages/Customers';
import Settings from './pages/Settings';
import AdUnit from './pages/AdUnit';

// --- Admin Components (Other) ---
import PortfolioForm from './components/admin/PortfolioForm';
import ProductForm from './components/admin/ProductForm';
import EBookForm from './components/admin/EBookForm';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter basename="/">
          <Routes>
            {/* --- Public Route ----------------------------------- */}
            <Route path="/login" element={<Login />} />

            {/* --- Protected Routes with Layout -------------------- */}
            <Route path="/" element={<FileManagerLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />

              {/* --- Content -------------------------------------- */}
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="products" element={<Products />} />
              <Route path="store" element={<StoreManager />} />
              <Route path="store/bulk" element={<BulkStoreUpload />} />
              <Route path="ebooks" element={<EBooks />} />

              {/* ?? ???? ???? (????? + ????) */}
              <Route path="blogs" element={<BlogPostsManagement />} />
              <Route path="blogs/new" element={<BlogFormPage />} />
              <Route path="blogs/edit/:id" element={<BlogFormPage />} />

              <Route path="videos" element={<Videos />} />
              <Route path="gallery" element={<Gallery />} />

              {/* --- Management ---------------------------------- */}
              <Route path="calculators" element={<Calculators />} />
              <Route path="customers" element={<Customers />} />
              <Route path="settings" element={<Settings />} />

              {/* --- Advertising ---------------------------------- */}
              <Route path="ads" element={<AdUnit />} />

              {/* --- Forms (Other) -------------------------------- */}
              <Route path="products/new" element={<ProductForm />} />
              <Route path="products/edit/:id" element={<ProductForm />} />
              <Route path="portfolio/new" element={<PortfolioForm />} />
              <Route path="portfolio/edit/:id" element={<PortfolioForm />} />
              <Route path="ebooks/new" element={<EBookForm />} />
              <Route path="ebooks/edit/:id" element={<EBookForm />} />

              {/* ===== PROPERTY PAGES ===== */}
              <Route path="properties" element={<Properties />} />
              <Route path="properties/new" element={<PropertyForm />} />
              <Route path="properties/edit/:id" element={<PropertyForm />} />
            </Route>

            {/* --- 404 Fallback ------------------------------------- */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;